import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ToastService } from '../../../../@theme/service/toast.service';
import { BlockType } from '../../../type/block-type';
import { Objects } from '../../../util/objects';

@Component({
  selector: 'ngx-common-block-link-column',
  template: ` <nb-icon class="mr-1" *ngIf="useSearch && params.value" style="cursor: pointer" icon="search-outline" status="primary" (click)="onClickSearch()"></nb-icon>
                <span [class.link-color]="useLinkColor && refId" [class.pointer]="refId" (click)="onClickLink()">{{ params.value }}</span>
               `,
  styles: [`
    .link-color {
      font-weight: bold;
      color: #00d68f;
    }
  `],
  encapsulation: ViewEncapsulation.None,
})
export class CommonBlockLinkComponent implements ICellRendererAngularComp {
  public params: ICellRendererParams;
  public data: any;
  public useSearch: boolean = false;
  public useLinkColor: boolean = false;
  public blockType: string;
  public refId: string;

  constructor(private router: Router, 
    private toast: ToastService) {}

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.data = this.params.data;
    this.useSearch = Objects.parseBoolean(Objects.safeGetValue(this.params, 'useSearch', 'false'));
    this.useLinkColor = Objects.parseBoolean(Objects.safeGetValue(this.params, 'useLinkColor', 'false'));
    this.blockType = this.params?.data?.blockType;
    this.refId = this.getId();
  }

  getId(): string {
    if (this.blockType == BlockType[BlockType.EXTERNAL_ACCESS]) {
      return this.params.data.containerId;
    } else {
      // TODO 유형별 ID 식별
      return this.params.data.instanceId;
    }
  }

  ngOnInit() {}

  onClickSearch(): void {
    if (this.blockType == BlockType[BlockType.EXTERNAL_ACCESS])
      this.params.context.setFilter('containerId', this.refId);
    else
      this.params.context.setFilter('instanceId', this.refId);
  }

  onClickLink(): void {
    console.debug(this.refId);

    if (!this.refId) return;

  }

}
